module.exports = __webpack_public_path__ + "static/media/IMG_0513.caefa14d.jpg";